import { z } from "zod";
import { GENRE_VALUES } from "../../constants/genre.js";
import { GENRE_SELECTION_MIN } from "../../constants/limits.js";
export const updateMyGenresSchema = z.object({
    genres: z
        .array(z.enum(GENRE_VALUES))
        .min(GENRE_SELECTION_MIN)
        .max(GENRE_VALUES.length)
        .refine((genres) => new Set(genres).size === genres.length, "Genres must be unique"),
});
